export const complianceConfirmationStyles = {
	root: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center'
	},

	content: {
		width: '90%'
	},

	checkbox: {
		py: 0,
		px: 1,
		'& .MuiSvgIcon-root': {
			fontSize: 20,
			width: 20,
			height: 20
		}
	},

	checkboxFormControl: {
		alignItems: 'center'
	},

	complianceConfirmationText: {
		fontSize: '0.75rem'
	}
};
